import { Accordion, Button, ButtonRounded, WModal } from '@components/atoms'
import { Close } from '@components/icons'
import { CheckboxFilterGroup, ColorFilterGroup, OrderByAccordion } from '@components/molecules'
import useTrans from '@hooks/useTrans'
import { AttributeItemType, FilterValueType, ListingItemtype } from '@utils/types'
import { SetStateAction } from 'react'
import styles from './ListingFiltersMobile.module.sass'

interface Props {
  open?: boolean
  onClose?: () => void
  item: ListingItemtype
  filters?: FilterValueType[]
  setFilters?: (filters: FilterValueType[]) => void
  orderBy?: string
  setOrderBy?: (orderBy: SetStateAction<string>) => void
  className?: string
}

const ListingFiltersMobile = (props: Props) => {
  const {
    open = false,
    onClose = undefined,
    item = undefined,
    filters = [],
    setFilters = undefined,
    orderBy = undefined,
    setOrderBy = undefined,
    className = '',
  } = props

  const t = useTrans()

  return (
    <WModal
      id="filterModal"
      open={open}
      onClose={onClose}
      className={`${styles.root} ${className}`}
    >
      <div className={styles.header}>
        <h3 className={styles.title}>{t('Filtra per:')}</h3>
        <ButtonRounded
          theme="neutral20"
          size="xs"
          className={styles.closeButton}
          icon={<Close />}
          onClick={onClose}
        />
      </div>

      <div className={styles.body}>
        <OrderByAccordion
          ordinamenti={item.ordinamenti}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          className={styles.orderBy}
        />
        {item.attributi?.length > 0 &&
          item.attributi.map((attr: AttributeItemType, i) => (
            <Accordion
              variant="filter"
              key={i}
              id={attr.chiave}
              label={attr?.label}
              className={styles.accordion}
              labelClassName={styles.accordionLabel}
            >
              {attr.chiave === 'colore' ? (
                <ColorFilterGroup attributo={attr} filters={filters} setFilters={setFilters} />
              ) : (
                <CheckboxFilterGroup attributo={attr} filters={filters} setFilters={setFilters} />
              )}
            </Accordion>
          ))}
      </div>

      <div className={styles.footer}>
        <Button variant="secondary" label={t('Azzera filtri')} onClick={() => setFilters([])} />
        <Button variant="primary" label={t('Applica filtri')} onClick={() => onClose()} />
      </div>
    </WModal>
  )
}

export default ListingFiltersMobile
